/* Rawtorque orb.
   A fibonacci sphere of dots, spun and tilted, with a scan meridian sweeping
   around it. Vanilla canvas so the storefront needs no React and no build step.
   Visual idea after thinking-orbs (github.com/Jakubantalik/thinking-orbs, MIT).

   Only ever attached to something genuinely in flight. */
(function () {
  'use strict';

  function hexToRgb(h) {
    h = String(h || '#E63946').replace('#', '');
    if (h.length === 3) { h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; }
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }

  function mount(el) {
    if (el.__rtOrb) { return; }
    el.__rtOrb = true;

    var size = parseInt(el.dataset.orbSize || '132', 10);
    var dots = parseInt(el.dataset.orbDots || '230', 10);
    var spin = parseFloat(el.dataset.orbSpin || '0.0042');
    var sweep = parseFloat(el.dataset.orbSweep || '1.7');
    var dotR = parseFloat(el.dataset.orbDot || '1.5');
    var redShare = parseFloat(el.dataset.orbRedShare || '0.22');
    var ink = el.dataset.orbInk !== 'false';
    var rgb = hexToRgb(el.dataset.orbAccent);
    var base = ink ? '29,29,31' : '255,255,255';

    var ctx = el.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    el.width = size * dpr;
    el.height = size * dpr;
    el.style.width = size + 'px';
    el.style.height = size + 'px';
    ctx.scale(dpr, dpr);

    var pts = [];
    for (var i = 0; i < dots; i++) {
      var y = 1 - (i / (dots - 1)) * 2;
      var r = Math.sqrt(Math.max(0, 1 - y * y));
      var th = i * 2.399963229728653;   // golden angle, so dots do not clump at the poles
      pts.push({ x: Math.cos(th) * r, y: y, z: Math.sin(th) * r, red: (i % 100) / 100 < redShare });
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tilt = 0.42, ct = Math.cos(tilt), st = Math.sin(tilt);
    var cx = size / 2, cy = size / 2, R = size * 0.40;
    var t = 0, raf = null, onScreen = true;

    function frame() {
      ctx.clearRect(0, 0, size, size);
      var ca = Math.cos(t), sa = Math.sin(t), sweepAng = t * sweep;
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i];
        var x1 = p.x * ca - p.z * sa;
        var z1 = p.x * sa + p.z * ca;
        var y2 = p.y * ct - z1 * st;
        var z2 = p.y * st + z1 * ct;
        var depth = (z2 + 1) / 2;
        var lon = Math.atan2(z1, x1);
        var d = Math.cos(lon - sweepAng);
        var hot = d > 0.9 ? (d - 0.9) / 0.1 : 0;
        var rad = dotR * (0.4 + depth * 0.8) + hot * dotR * 0.9;
        var a = Math.min(1, (0.12 + depth * 0.60) + hot * 0.3);
        ctx.fillStyle = (p.red || hot > 0.2)
          ? 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + a.toFixed(3) + ')'
          : 'rgba(' + base + ',' + (a * 0.8).toFixed(3) + ')';
        ctx.beginPath();
        ctx.arc(cx + x1 * R, cy + y2 * R, rad, 0, 6.283185);
        ctx.fill();
      }
      if (!reduce) { t += spin; raf = requestAnimationFrame(frame); }
    }

    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
    function go() { if (!raf && !reduce) { raf = requestAnimationFrame(frame); } }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else if (onScreen) { go(); }
    });
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        onScreen = !!(es[0] && es[0].isIntersecting);
        if (onScreen) { go(); } else { stop(); }
      }).observe(el);
    }
    frame();
  }

  function init() {
    var list = document.querySelectorAll('canvas.rt-orb');
    for (var i = 0; i < list.length; i++) { mount(list[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
